<template>
  <b-modal
    id="modalDeviceInfo"
    v-model="localIsActive"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    size="md"
    header-bg-variant="primary"
    @show="fetchData()"
    @hidden="closeModal()"
  >
    <template #modal-title>
      <span class="text-white">Información del dispositivo - {{ hanwhaDvr.name }}</span>
    </template>

    <div v-if="loadingFetchData" class="tab-content-loading d-flex justify-content-center align-items-center">
      <b-spinner label="Loading" variant="primary" />
    </div>
    <div v-else class="content-device-info">
      <p>Información general</p>
      <table class="table table-sm table-bordered mt-1">
          <colgroup>
            <col style="width: 50%">
            <col style="width: 50%">
          </colgroup>
          <tr>
            <th class="text-center font-weight-normal">
              Nombre del modelo
            </th>
            <td class="text-center">
              {{ itemData.model_name }}
            </td>
          </tr>
          <tr>
            <th class="text-center font-weight-normal">
              Versión del software
            </th>
            <td class="text-center">
              {{ itemData.software_version }}
            </td>
          </tr>
          <tr
            v-for="(macAddress, index) in itemData.mac_addresses"
            :key="index"
          >
            <th class="text-center font-weight-normal">
              Dirección MAC {{ index + 1 }}
            </th>
            <td class="text-center">
              {{ macAddress }}
            </td>
          </tr>
        </table>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="user_id"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              label="Nombre de dispositivo"
              label-for="device_name"
              description="Maximo 30 caracteres."
            >
              <b-form-input
                id="usedevice_namer_id"
                v-model="itemData.device_name"
                maxlength="30"
                :state="getValidationState(validationContext)"
                :disabled="loading"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="text-right">
            <b-button
              type="submit"
              variant="primary"
              :disabled="loading"
            >
              Guardar
            </b-button>
          </div>
        </b-form>
    </validation-observer>
  </div>
  </b-modal>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { required } from '@validations';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";

export default {
  props: {
    hanwhaDvr: {
      type: Object,
      require: true
    },
    isModalDeviceInfoActive: {
      type: Boolean,
      require: true
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      required
    }
  },
  setup (props, { emit }) {
    const resetData = () => {
      itemData.value.name = null;
      itemData.value.mac_addresses = [];
    }

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const itemData = ref({
      device_name: null,
      model_name: null,
      name: null,
      mac_addresses: null,
      networks: []
    });

    const loading = ref(false);

    const loadingFetchData = ref(false);

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.isModalDeviceInfoActive;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const closeModal = () => {
      resetData();
      emit('close-modal');
    }

    const fetchData = async () => {
      loadingFetchData.value = true;

      await getDeviceInfo();
      await getNetworksInfo();

      loadingFetchData.value = false;

    }

    const getDeviceInfo = async () => {
      const params = {
        id_dvr: props.hanwhaDvr.id,
        action: 'device-info',
        params: {}
      }

      await axios.get('/v1/hanwha/dvr/admin/get_device_info', { params })
        .then(response => {
          const { data } = response;
          const errorDeviceInfo = (data.Response && data.Response === 'Fail')

          if (!errorDeviceInfo) {
            itemData.value.model_name = data.data.Model;
            itemData.value.device_name = data.data.DeviceName;
            itemData.value.software_version = data.data.FirmwareVersion;
          }
        })
    }

    const getNetworksInfo = async () => {
      const params = {
        idDvr: props.hanwhaDvr.id
      }

      await axios.get('/v1/hanwha/dvr/admin/get_network_info', { params })
        .then((response) => {
          const { data } = response;
          const errorNetworkInfo = (data.Response && data.Response === 'Fail')

          if (!errorNetworkInfo) {
            itemData.value.mac_addresses = data.data.NetworkInterfaces.map(ni => ni.MACAddress);
          }
        });
    }

    const onSubmit = async () => {
      const request = {
        id_dvr: props.hanwhaDvr.id,
        device_name: itemData.value.device_name
      }

      loading.value = true;

      await axios.post('/v1/hanwha/dvr/admin/set-device-name', request)
        .then(async (response) => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          fetchData();
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error al guardar la información',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      getValidationState,
      resetForm,
      refFormObserver,

      itemData,
      loading,
      loadingFetchData,

      localIsActive,

      closeModal,
      fetchData,
      onSubmit
    }
  }
}
</script>

<style scoped>
.tab-content-loading {
  height: 250px !important;
}

.content-device-info {
  min-height: 250px !important;
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
